import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterSelect } from './filters/filter_select';
import { Filters } from '../../../../constants/filter/filters';
import { getDefaultValueForFilter } from '../../../../helper/filters/get_default_value_for_filter';

function Brand(props) {
    const opened = props.opened || !!props.brandValue || !!props.modelValue;

    let modelOptions = [];
    if (getDefaultValueForFilter(Filters.MANUFACTURER) !== props.brandValue) {
        // brand has a user chosen value
        modelOptions = props.modelOptions;
    }

    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline='catalog-filters-section-headline-brand'
            containerModifier="brand"
        >
            <FilterSelect
                name={Filters.MANUFACTURER}
                value={props.brandValue}
                options={props.brandOptions}
                labelTranslationKey="catalog-filters-manufacturer-select-label"
                provideAllTranslationKey="catalog-filters-manufacturer-select-label-all"
                onChange={props.onBrandChange}
                provideAllOption={true}
                showTooltip={false}
                highlight={!props.brandValue}
            />

            <FilterSelect
                name={Filters.MODEL}
                value={props.modelValue}
                options={modelOptions}
                labelTranslationKey="catalog-filters-model-select-label"
                provideAllTranslationKey="catalog-filters-model-select-label-all"
                onChange={props.onModelChange}
                provideAllOption={true}
                disabled={!modelOptions.length}
                highlight={!!props.brandValue && !props.modelValue}
                loading={props.modelOptionsLoading}
                showTooltip={false}
            />
        </FilterSection>
    );
}

Brand.propTypes = {
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    modelValue: PropTypes.string.isRequired,
    brandValue: PropTypes.string.isRequired,
    modelOptions: PropTypes.array.isRequired,
    modelOptionsLoading: PropTypes.bool.isRequired,
    brandOptions: PropTypes.array.isRequired,
    onToolTipHover: PropTypes.func.isRequired,
    onBrandChange: PropTypes.func.isRequired,
    onModelChange: PropTypes.func.isRequired,
};

export { Brand };
